import { useSearchParams } from "react-router-dom";
import { ActiveExpeditionType } from "../../../redux/interfaces/expedition.interface";

export default function useActiveExpeditionType(): ActiveExpeditionType {
  const [searchParams] = useSearchParams();
  return searchParams.get("type") === "pickup" ? "pickup" : "delivery";
}
